//github.com/smooth-code/react-merge-refs/issues/5

import React from 'react';

export function useMergeRefs(refs) {
  const currentRefs = React.useRef(refs);
  const currentValue = React.useRef(null);

  React.useEffect(() => {
    if (currentValue !== null) {
      const added = refs.filter(ref => !currentRefs.current.includes(ref));
      const removed = currentRefs.current.filter(ref => !refs.includes(ref));

      updateRefs(removed, null);
      updateRefs(added, currentValue.current);
    }

    currentRefs.current = refs;
  });

  return React.useCallback(value => {
    updateRefs(currentRefs.current, value);
    currentValue.current = value;
  }, []);
}

function updateRefs(refs, value) {
  refs.forEach(ref => {
    if (typeof ref === 'function') {
      ref(value);
    } else if (ref !== null) {
      ref.current = value;
    }
  });
}
